module.exports = __webpack_public_path__ + "static/media/ic_pay_paypal.e3b3d713.svg";